import {useEffect, useRef} from "react";
import React from "react";

export const FunctionalModal = ({component: Component, setOpen}) => {

    const shadowRef = useRef(null)

    // TODO : instead of ref and className =>doing an onBlur with setOpen
    const exitDetailHandler = (e) => {
        const element = e.target.className;
        const shadow = shadowRef.current.className
        if (element === shadow) {
            setOpen(false)
        }
    }

    useEffect(() => {
        document.body.style.overflow = "hidden"
        return function cleanup() {
            document.body.style.overflow = "auto"
        }
    }, [])

    return (
        <div ref={shadowRef} className={"shadow"} onClick={exitDetailHandler}>
            {Component}
        </div>
    )
}
